import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel } from '@mui/material';
import ChekboxInput from './Checkbox';

function EditorChekboxInput({ label, onDoubleClick, ...restProps }) {
  return (
    <FormControlLabel
      control={<ChekboxInput {...restProps} />}
      label={label}
      onDoubleClick={onDoubleClick}
    />
  );
}

EditorChekboxInput.propTypes = {
  label: PropTypes.string,
  onDoubleClick: PropTypes.func,
};

EditorChekboxInput.defaultProps = {
  label: '?',
  onDoubleClick: null,
};

export default memo(EditorChekboxInput);
